import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueFormulate from '@braid/vue-formulate';
import { pt } from '@braid/vue-formulate-i18n';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import store from './store';
import VeeValidate, { Validator } from 'vee-validate';
import pt_BR from 'vee-validate/dist/locale/pt_BR';
import Vuetify from 'vuetify'
import SgpComponents from '@/plugins/sgpComponents'
import DatetimePicker from 'vuetify-datetime-picker'
import { possuiPermissao } from '@/common/boot/PermissionamentoHandler.js'
import { slugfy } from '@/common/helpers/StringHelper';
import ModosWebComponents from '@/plugins/modosWebComponents'

// habilita permissionamento na instancia principal do Vue
Vue.prototype.$permissionamento = {
    possuiPermissao
}

Vue.prototype.$slugfy = slugfy

Vue.use(DatetimePicker)
Vue.use(Vuetify)

const opts = {}
export default new Vuetify(opts)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueCurrencyInput from 'vue-currency-input'
const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'BRL', precision: 2, autoDecimalMode: true}
}
Vue.use(VueCurrencyInput, pluginOptions)

Vue.config.productionTip = false;

Vue.use(VueFormulate, {
    locale: 'pt',
    plugins: [pt]
});

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Validator.localize('pt_BR', pt_BR);

Validator.extend('after_or_equal_today', {
  getMessage: field => `${field} deve ser hoje ou uma data futura.`,
  validate: value => {
    if (!value) return true;
    const inputDate = new Date(value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return inputDate >= today;
  }
});

Vue.use(VeeValidate, {
    locale: 'pt_BR',
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    },
    validity: true,
    errorBagName: 'validationErrors',
    fieldsBagName: 'validationFields'

})

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 4,
    newestOnTop: true,
    filterBeforeCreate: (toast, toasts) => {
        if (toasts.filter(
          t => t.type === toast.type
        ).length !== 0) {
          // Returning false discards the toast
          return false;
        }

        if (toast.content === 'Unauthenticated.') {
            return false;
        }
        // You can modify the toast if you want
        return toast;
    }
});

//////////// DIRETIVAS //////////////////////////////
Vue.directive('fechar-modal', {
    bind(el, binding, vnode) {
        el.addEventListener('click', () => {
            const sgpModal = vnode.context.$parent.$parent.$parent.$parent

            if (typeof sgpModal.fecharModal === 'function') {
                sgpModal.fecharModal()
            } else {
                vnode.context.$children[0].fecharModal()
            }
        })
    }
})

import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(SgpComponents)
Vue.use(ModosWebComponents)

// silenciar os warnings
Vue.config.silent = true

new Vue({
    render: h => h(App),
    store,
    vuetify,
    router
}).$mount('#app')